module.exports = __webpack_public_path__ + "assets/img/ja-eb103437.png";